var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.48288 1.4555C9.07532 1.4555 10.441 2.16414 11.3461 3.42634H8.81345V4.74023H13.4704V0.141602H12.1398V2.29005C10.9922 0.918449 9.34849 0.141602 7.48288 0.141602C3.80864 0.141602 0.830078 3.08285 0.830078 6.71107H2.16064C2.16064 3.8085 4.54349 1.4555 7.48288 1.4555ZM7.48288 11.9666C5.89045 11.9666 4.52474 11.258 3.61964 9.9958H6.15232V8.68191H1.49536V13.2805H2.82592V11.1321C3.9736 12.5037 5.61728 13.2805 7.48288 13.2805C11.1571 13.2805 14.1357 10.3393 14.1357 6.71107H12.8051C12.8051 9.61364 10.4223 11.9666 7.48288 11.9666Z",
    fill: "#CE2600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.f8315f7a5280470a3a5f073ef2edf3d0.svg";
export { ForwardRef as ReactComponent };